import { apiGet, apiPost } from './client'

/**
 * Scrierile ecranului "Oncall Users" - `Easeedesk::addOncallUser`,
 * `editOncallUser`, `removeOncallUser` si lista din care se alege omul
 * (`getGroupUsers`).
 *
 * Citirile ecranului stau in `api/easeedeskBoards.ts`, unde le-a pus banda
 * care a mutat ecranul; fisierul asta e numai al scrierilor, ca la impacare
 * cele doua benzi sa nu se bata pe acelasi fisier.
 */

export interface OncallCandidate {
  id: number
  name: string
}

export interface OncallCandidates {
  group: number
  users: OncallCandidate[]
}

/** Cele patru campuri ale ferestrei, ca in machetele `oncall/index.php`. */
export interface OncallUserForm {
  user_id: number
  date_from: string
  date_to: string
  oncall_phone: string
}

export function oncallCandidatesQuery(group: number) {
  return {
    queryKey: ['easeedesk', 'oncall', 'candidates', group] as const,
    queryFn: () => apiGet<OncallCandidates>(`/easeedesk/oncall/${group}/candidates`),
    /* Grupul 0 inseamna "nimic ales inca" in fereastra de adaugare. */
    enabled: group > 0,
  }
}

export function addOncallUser(group: number, form: OncallUserForm): Promise<{ ok: boolean; id: number }> {
  return apiPost('/easeedesk/oncall/users', { group, ...form })
}

export function editOncallUser(id: number, form: OncallUserForm): Promise<{ ok: boolean }> {
  return apiPost(`/easeedesk/oncall/users/${id}`, { ...form })
}

export function removeOncallUser(id: number): Promise<{ ok: boolean }> {
  return apiPost(`/easeedesk/oncall/users/${id}/remove`, {})
}

/** "Open ticket": tichetul de garda, ca `easeedesk/openOncallTicket`. */
export function openOncallTicket(): Promise<{ ok: boolean; ticket: number }> {
  return apiPost('/easeedesk/oncall/ticket', {})
}
